import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b08082886e100014b1feb8/nordic_trading_platform/src/app/not-found.tsx");
